module.exports = __webpack_public_path__ + "static/media/HDI.b4172167.jpg";